import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import { routes, type Role, type User } from "@nova-ai/shared"

import { apiFetch } from "../lib/api"
import { queryKeys } from "./query-keys"

export function useUsers() {
  return useQuery({
    queryKey: queryKeys.users,
    queryFn: async () => {
      const result = await apiFetch<{ users: User[] }>(routes.users.list())
      if (!result.ok) {
        throw new Error(result.error.message)
      }

      return result.value.users
    },
  })
}

export function useSetUserRole() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ id, role }: { id: number; role: Role }) => {
      const result = await apiFetch<{ user: User }>(routes.users.role({ id: String(id) }), {
        method: "PUT",
        body: { role },
      })
      if (!result.ok) {
        throw new Error(result.error.message)
      }

      return result.value.user
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.users })
    },
  })
}
